// extracted by mini-css-extract-plugin
export default {"login-wrapper":"Login_login-wrapper__lxi+w","input-wrapper":"Login_input-wrapper__00enN"};